export default "__VITE_ASSET__noqgmn9n__"